import { render, staticRenderFns } from "./FlatSelectorIconSwitch.component.vue?vue&type=template&id=752c1e42&scoped=true&lang=pug"
import script from "./FlatSelectorIconSwitch.component.vue?vue&type=script&lang=ts"
export * from "./FlatSelectorIconSwitch.component.vue?vue&type=script&lang=ts"
import style0 from "./FlatSelectorIconSwitch.component.vue?vue&type=style&index=0&id=752c1e42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "752c1e42",
  null
  
)

export default component.exports